// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605051503/js/" + chunkId + "." + {"44":"54966cd6","225":"cc430227","481":"57003537","486":"a512e641","770":"0dfe830f"}[chunkId] + ".0.5771390387561655.chunk.js";
};